import { CartItem } from '@/types/pos';

export const InvoiceService = {
    async getInvoiceItems (invoiceId: string): Promise<CartItem[]> {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/invoice/${invoiceId}/items`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Failed to fetch invoice items');
        }

        const data = await response.json();
        return data.data as CartItem[];
    }
}